/**
 * システム管理ホームページ専用i18n定数
 */

export const SYSTEM_ADMIN_HOME_I18N = {
  // ページタイトル
  title: {
    dashboard: $localize`:@@systemAdmin.home.title.dashboard:ダッシュボード`,
  },
  // チャートラベル
  chart: {
    xAxisPeriodOfUse: $localize`:@@systemAdmin.home.chart.xAxisPeriodOfUse:利用期間（日）`,
    yAxisAccountCount: $localize`:@@systemAdmin.home.chart.yAxisAccountCount:アカウント数（件）`,
  },
  // ラベル
  label: {
    monthOverMonth: $localize`:@@systemAdmin.home.label.monthOverMonth:前月比`,
  },
} as const;

export type SystemAdminHomeI18n = typeof SYSTEM_ADMIN_HOME_I18N;
